import { IAppState } from '../common/state';
import { selectEmptyState } from './results/selectEmptyState';

/**
 * Признак того, что нужно показать блок пустой выдачи: объявлений нет и ручка поиска
 * прислала emptyState.
 */
export function selectIsEmptyStateVisible(state: IAppState): boolean {
  return state.results.offers.length === 0 && Boolean(selectEmptyState(state));
}
